// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { SidePassSide } from "./SidePassSide.gen";

export interface IDriverSidePassRequest {
	side: SidePassSide;

	lanes: number | undefined;

	minSpeed: number | undefined;

	$type?: string | undefined;
}
export class DriverSidePassRequest {
	constructor(data?: IDriverSidePassRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	side: SidePassSide = 0;

	lanes: number | undefined;

	minSpeed: number | undefined;

	static $type: string = "CoreApi.Models.DriverSidePassRequest, ";
	$type?: string | undefined = DriverSidePassRequest.$type;
}

